module.exports = __webpack_public_path__ + "img/77.801317b.png";